export default{
  setPolicies: (state, payload) => {state.policies = payload},
  setTerms: (state, payload) => {state.terms = payload},
}